import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import {
  useAddPositionsMutation,
  useDeletePositionsMutation,
  useEditPositionsMutation
} from "../../../../redux/api/handBooksApi/positionsApi";
import { EntPositions } from "../../../../models/handBooks/positions";

const usePosition = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;
  const [addPosition] = useAddPositionsMutation();
  const [deletePosition] = useDeletePositionsMutation();
  const [editPosition] = useEditPositionsMutation();

  async function onAddPosition(newPosition: EntPositions): Promise<boolean> {
    try {
      let status: boolean = false;
      await addPosition(newPosition).then((response: any) => {
        if (response.error !== undefined) {

          throw new Error(response.error.data.message);
        }
        if (response.data.success) {
          status = true;
          message.success(t('msg.successAdd'));
          if(refresh) refresh();
        }
      }).catch((error:any) => {
        modal.error({ title: t('msg.error'), content: String(error.message) });

      });
      return status;
    } catch (error: any) {
      modal.error({ title: t('msg.error'), content: String(error.message) });
      return false;
    }
  }
  async function onDeletePosition(positions: EntPositions) {
    try {
      let status: boolean = false;
      confirm({
        centered: true,
        title: t('msg.confirmDeleteText'),
        okText: t('general.yes'),
        cancelText: t('general.no'),
        onOk() {
          deletePosition(positions.id).then((response: any) => {
            if (response.error !== undefined && response.error.status === 400) {
              status = false;
              throw new Error(response.error.data.message);
            }
            if (response.data.success) {
              status = true;
              Modal.success({title: t('msg.successDelete')});
              if(refresh) refresh();
            }
          }).catch((error: any) => {
            Modal.error({ title: t('msg.error'), content: String(error.message) });

          });
        }
      })
      return status
    } catch (error: any) {
      Modal.error({ title: t("msg.error"), content: String(error.message) });
      return false;
    }
  };
  async function onEditPosition(editedPosition: EntPositions): Promise<boolean> {
    try {
      let status: boolean = false;
      await editPosition(editedPosition).then((response: any) => {
        if (response.error !== undefined && response.error.status === 400) {
          throw new Error(response.error.data.message);
        }
        if (response.data.success) {
          status = true;
          Modal.success({title: t('msg.successEdited')});
          if(refresh) refresh();
        }
      }).catch((error: any) => {
        Modal.error({ title: t('msg.error'), content: String(error.message) });
      });
      return status;
    } catch (error: any) {
      Modal.error({ title: t("msg.error"), content: String(error.message) });
      return false;
    }
  };
  return { onAddPosition,onDeletePosition, onEditPosition }

}
export { usePosition };

